// @flow

import { getItem, getQuery } from '../../common'

import { sendRestartMessage } from '../utils/api'
import { CHATBOT_PAYLOAD_KEY } from '../models/Chatbot'

import postMessageMixin from '../mixins/postMessageMixin'

export default {
  mixins: [postMessageMixin],
  methods: {
    handleRestart () {
      sendRestartMessage(getQuery('chatbotPayload') || getItem(CHATBOT_PAYLOAD_KEY))
      this.notifyRestart()
    }
  }
}
